/* ============================================================================
   ATELIER — product reviews (deterministic, time-rotating)
   - Picks 15 short, imperfect reviews from a pool, seeded by the product handle
     + a 30-minute time window, so the set rotates every 30 min but is stable
     within a visit.
   - Shows 6, then a "Show more" button reveals the rest (up to 15).
   - The rating SUMMARY reuses window.AtRatings.ratingFor(handle) so it matches
     the product-info rating exactly (NOT averaged from the cards).
   Needs at-ratings.js loaded first (window.AtRatings).
   ========================================================================== */
(function () {
  var POOL = [
    'arrived fast, quality looks legit', 'good product will order again',
    'packaging solid and the coa matched', 'havent fully tested but looks good so far',
    'shipping took a lil bit but worth it', 'purity checks out. happy',
    'second time ordering, real consistent', 'reconstituted fine no issues at all',
    'great comms n fast ship', 'everything as described tbh',
    'legit vendor coa provided np', 'works as expected so far',
    'vial was packed really well', 'no complaints solid batch',
    'quick delivery will return', 'quality is there imo',
    'matches the hplc they sent over', 'good stuff ordering more soon',
    'cold pack included, nice touch', 'did what i needed for research',
    'clean product labels clear', 'fast turnaround even w the holidays',
    'hplc n mass spec both provided, legit', 'been using for weeks consistent',
    'shipped discreet arrived sealed', 'honestly better than my last supplier',
    'batch was fresh dated recent', 'customer service answered quick',
    'no leaks everything intact', 'solid purity would recommend',
    'reordered 3x now never a problem', 'the coa link actually worked, appreciate it',
    'decent price for the quality', 'came earlier than expected',
    '5 stars from me no notes', 'well documented, cant complain'
  ];
  var NAMES = [
    'Marcus T.', 'kayla_r', 'J. Whitfield', 'd.reyes', 'labrat91', 'Priya S.',
    'Owen', 'm_carter', 'Devon L.', 'sara', 'T. Nguyen', 'chris__', 'A. Okafor',
    'jordan', 'Riya M.', 'ben', 'L. Petrov', 'mikey', 'Hannah K.', 'Sam',
    'roberto', 'Yuki T.', 'Nate', 'elena', 'Q. Adams'
  ];

  function h(str) {
    if (window.AtRatings) return window.AtRatings.hash(str);
    str = String(str);
    var x = 2166136261;
    for (var i = 0; i < str.length; i++) { x ^= str.charCodeAt(i); x = (x * 16777619) >>> 0; }
    return x >>> 0;
  }
  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function relDate(days) {
    if (days < 7) return days + (days === 1 ? ' day ago' : ' days ago');
    if (days < 30) { var w = Math.round(days / 7); return w + (w === 1 ? ' week ago' : ' weeks ago'); }
    var m = Math.round(days / 30); return m + (m === 1 ? ' month ago' : ' months ago');
  }
  function starsHTML(rating) {
    return window.AtRatings ? window.AtRatings.starsHTML(rating, ' at-stars--sm') : '';
  }

  function build(handle) {
    var win = Math.floor(Date.now() / (30 * 60 * 1000)); // 30-minute window
    var seed = (h(handle) ^ Math.imul(win, 2654435761)) >>> 0;
    var rng = mulberry32(seed);
    var idx = POOL.map(function (_, i) { return i; });
    for (var i = idx.length - 1; i > 0; i--) {
      var j = Math.floor(rng() * (i + 1));
      var t = idx[i]; idx[i] = idx[j]; idx[j] = t;
    }
    return idx.slice(0, 15).map(function (pi, k) {
      var r = rng();
      var stars = r < 0.68 ? 5 : (r < 0.88 ? 4.5 : 4);
      return {
        text: POOL[pi],
        name: NAMES[h(handle + ':' + pi + ':' + k) % NAMES.length],
        stars: stars,
        days: 2 + (h(handle + 'd' + pi) % 40),
        verified: (h(handle + 'v' + pi) % 5) !== 0
      };
    });
  }

  function card(rev) {
    return '<article class="at-review">' +
        '<div class="at-review__top">' +
          '<span class="at-review__name">' + rev.name + '</span>' +
          (rev.verified ? '<span class="at-review__verified">verified buyer</span>' : '') +
        '</div>' +
        '<div class="at-review__stars">' + starsHTML(rev.stars) + '</div>' +
        '<p class="at-review__text">' + rev.text + '</p>' +
        '<span class="at-review__date">' + relDate(rev.days) + '</span>' +
      '</article>';
  }

  function render(el) {
    var handle = el.getAttribute('data-at-handle');
    if (!handle) return;
    var list = el.querySelector('[data-at-reviews-list]');
    var moreBtn = el.querySelector('[data-at-reviews-more]');
    var initial = parseInt(el.getAttribute('data-initial'), 10) || 6;
    var reviews = build(handle);

    list.innerHTML = reviews.map(card).join('');
    list.querySelectorAll('.at-review').forEach(function (c, i) {
      if (i >= initial) c.classList.add('at-review--hidden');
    });

    if (moreBtn) {
      if (reviews.length <= initial) {
        moreBtn.hidden = true;
      } else {
        moreBtn.addEventListener('click', function () {
          list.querySelectorAll('.at-review--hidden').forEach(function (c) { c.classList.remove('at-review--hidden'); });
          moreBtn.hidden = true;
        });
      }
    }
  }

  function run() {
    document.querySelectorAll('[data-at-reviews]').forEach(function (el) {
      if (!el.__atRev) { el.__atRev = true; render(el); }
    });
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
